module.exports = __webpack_public_path__ + "img/register.b8dddcbe.png";